<div *ngIf="show" class="upsell-payment-failed-overlay">
  <div class="overlay-backdrop"></div>
  <div class="confirmation-content" fxLayout="column" fxLayoutAlign="center center">
    <mat-icon class="close-icon" [attr.aria-label]="('upsellPaymentFailed.closeAria' | translate)" (click)="dismiss.emit()"
              [trackClick]="{ page: 'Link Clicked', linklocation: trackLocation || 'Upsell Page', linktype: 'icon', linkname: 'Close Payment Failed', linkurl: trackUrl || 'addon_payment_failed_close' }">close</mat-icon>
    <!-- Icon and Text - Desktop layout (hidden on mobile) -->
    <div class="confirmation-header desktop-layout" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px" fxHide.xs>
      <div class="warning-icon">
        <img [src]="iconSrc" [attr.alt]="iconAlt || ('upsellPaymentFailed.iconAlt' | translate)">
      </div>
      <div class="confirmation-text">
        <p>
          {{ message || ('upsellPaymentFailed.message' | translate) }}<br *ngIf="details" /> <ng-container *ngIf="details">{{ details }}</ng-container>
        </p>
      </div>
    </div>

    <!-- Icon and Text - Mobile layout (hidden on desktop) -->
    <div class="confirmation-header mobile-layout" fxLayout="column" fxLayoutAlign="center center" fxHide.gt-xs>
      <div class="warning-icon">
        <img [src]="iconSrc" [attr.alt]="iconAlt || ('upsellPaymentFailed.iconAlt' | translate)">
      </div>
      <div class="confirmation-text">
        <p>
          {{ message || ('upsellPaymentFailed.message' | translate) }}<br *ngIf="details" /> <ng-container *ngIf="details">{{ details }}</ng-container>
        </p>
      </div>
    </div>

    <!-- Action Buttons - Desktop layout (hidden on mobile) -->
    <div class="confirmation-actions desktop-layout" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px" fxHide.xs>
      <button
        mat-stroked-button
        class="confirm-btn"
        (click)="updatePaymentMethod.emit()"
        [disabled]="loading"
        [trackClick]="{ page: 'Update Payment Method Button Clicked', location: trackLocation }">
        {{ (closeLabel || ('upsellPaymentFailed.updatePaymentMethodLabel' | translate)) | uppercase }}
      </button>
      <button
        mat-stroked-button
        color="accent"
        class="confirm-btn cancel-btn"
        [ngClass]="{'loading': loading}"
        (click)="retry.emit()"
        [disabled]="loading"
        [trackClick]="{ page: 'Try Again Button Clicked', location: trackLocation }">
        <mat-spinner *ngIf="loading" diameter="16" class="button-spinner"></mat-spinner>
        <span *ngIf="!loading">{{ (retryLabel || ('upsellPaymentFailed.retryLabel' | translate)) | uppercase }}</span>
      </button>
    </div>

    <!-- Action Buttons - Mobile layout (hidden on desktop) -->
    <div class="confirmation-actions mobile-layout" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="12px" fxHide.gt-xs>
      <button
        mat-stroked-button
        color="accent"
        class="confirm-btn cancel-btn"
        [ngClass]="{'loading': loading}"
        (click)="retry.emit()"
        [disabled]="loading"
        [trackClick]="{ page: 'Try Again Button Clicked', location: trackLocation }">
        <mat-spinner *ngIf="loading" diameter="16" class="button-spinner"></mat-spinner>
        <span *ngIf="!loading">{{ (retryLabel || ('upsellPaymentFailed.retryLabel' | translate)) | uppercase }}</span>
      </button>
      <button
        mat-stroked-button
        class="confirm-btn"
        (click)="updatePaymentMethod.emit()"
        [disabled]="loading"
        [trackClick]="{ page: 'Update Payment Method Button Clicked', location: trackLocation }">
        {{ (closeLabel || ('upsellPaymentFailed.updatePaymentMethodLabel' | translate)) | uppercase }}
      </button>
    </div>
  </div>
</div>
